import axios from 'axios';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import AccionesCell from '../components/AccionesCell'; // Ajusta la ruta según tu estructura

const fetchTrafficCabeceraData = async (id_orden_detalle, onEdit, onDelete) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header/`, {
      params: { id_orden_detalle }
    });
    const trafficData = response.data;
    console.log(trafficData);
    // Mapeamos los datos recibidos para ajustar la estructura de la tabla
    const rows = trafficData.map(item => ({
      op: item.op, // Número de OP
      hawbHbl: item.documento, // Número HAWB/HBL (clave 'documento' en la API)
      acciones: (
        <AccionesCell
          onEdit={() => onEdit(item)}
          onDelete={() => onDelete(item)}
        />
      ),
    }));

    return {
      columns: [
        {
          Header: '# OP',
          accessor: 'op',
          // eslint-disable-next-line react/prop-types
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: '#HAWB/ HBL',
          accessor: 'hawbHbl',
          // eslint-disable-next-line react/prop-types
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Acciones',
          accessor: 'acciones',
          Cell: ({ row }) => row.original.acciones,
        },
      ],
      rows,
    };
  } catch (error) {
    console.error('Error fetching traffic cabecera data:', error);
    return { columns: [], rows: [] };
  }
};

export default fetchTrafficCabeceraData;
